export default {"src":"/_next/static/media/chickpea.c404b2dd.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};